export const columnTemplates = [
  {
    type: 'field',
    fieldName: 'Country_Name',
    label: 'Country Name',
    autoWidth: true,
  },
  {
    type: 'field',
    fieldName: 'Sample_Count',
    label: 'Sample Count',
    autoWidth: true,
  },
] as any;
